import { useFormikContext } from 'formik'
import { useCallback } from 'react'

import { DEPRECIATION_FIELDS } from '../const'
import { genLedgerFieldName } from '../helper'
import { getDefaultServiceLife } from '../helpers/service-life'

export const useDepreciationMethodChanged = (ledgerIndex: number, afterDepreciationChanged: () => void) => {
  const { setFieldValue } = useFormikContext()
  const serviceLifeField = genLedgerFieldName(DEPRECIATION_FIELDS.SERVICE_LIFE, ledgerIndex)

  return useCallback(
    (depreciationCode?: number | string) => {
      setFieldValue(serviceLifeField, getDefaultServiceLife(depreciationCode))
      afterDepreciationChanged()
    },
    [serviceLifeField, afterDepreciationChanged]
  )
}
